import { render } from "./DownloadListDialog.vue?vue&type=template&id=258b7904"
import script from "./DownloadListDialog.vue?vue&type=script&lang=js"
export * from "./DownloadListDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__